export default __webpack_public_path__ + "static/media/footer-logo.53630d70.png";